import { Input } from '../../../../components/ui/input';

interface PicFilterProps {
  pic: string;
  onPicChange: (value: string) => void;
}

export function PicFilter({ pic, onPicChange }: PicFilterProps) {
  return (
    <div className="flex items-center gap-2">
      <Input
        placeholder="PIC"
        value={pic}
        onChange={(e) => onPicChange(e.target.value)}
        style={{ width: '160px' }}
      />
    </div>
  );
}
